// Auto generated file, do not manually modify!
// com.hotpads.idverification.handler.web.IdVerificationWebApiHandler

import type { UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  IdVerificationWebApiHandler_acceptTerms,
  IdVerificationWebApiHandler_getTermSet,
  IdVerificationWebApiHandler_getTermSet_Path,
  IdVerificationWebApiHandler_isIpAddressInTheUs,
  IdVerificationWebApiHandler_isIpAddressInTheUs_Path,
  IdVerificationWebApiHandler_isUserIdentified,
  IdVerificationWebApiHandler_isUserIdentified_Path,
  IdVerificationWebApiHandler_performIdentityCheck,
  IdVerificationWebApiHandler_submitIdentityCheckAnswers,
} from '@zg-rentals/ts-id-verification-client';

import type {
  AcceptTermsWebApiRequestDto,
  GetTermSetWebApiResponseDto,
  IsUserIdentifiedResponseDto,
  PerformIdentifyCheckRequestDto,
  PerformIdentifyCheckResponseDto,
  SubmitIdentityCheckAnswersForPassiveAuthRequestDto,
  SubmitIdentityCheckAnswersResponseDto,
  TermSetId,
  ZgAuthZone,
} from '@zg-rentals/ts-id-verification-client';

interface GetTermSetParams {
  termSetId: TermSetId;
}
interface IsUserIdentifiedParams {
  requestingClient: string;
  zgAuthZone: ZgAuthZone;
}

export interface IdVerificationWebApiHandler_acceptTerms_Args {
  postData: AcceptTermsWebApiRequestDto;
}

export type IdVerificationWebApiHandler_acceptTerms_Options = UseMutationOptions<
  void,
  unknown,
  IdVerificationWebApiHandler_acceptTerms_Args
>;

export const useIdVerificationWebApiHandler_acceptTerms = ({
  httpClient,
  ...options
}: Omit<IdVerificationWebApiHandler_acceptTerms_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: IdVerificationWebApiHandler_acceptTerms_Args) =>
      IdVerificationWebApiHandler_acceptTerms(args.postData, httpClient),
  });
};

export type IdVerificationWebApiHandler_getTermSet_Options = UseQueryOptions<
  GetTermSetWebApiResponseDto,
  unknown,
  GetTermSetWebApiResponseDto,
  Array<string | GetTermSetParams>
>;

const IdVerificationWebApiHandler_getTermSet_GetKey = (getParams: GetTermSetParams) => [
  IdVerificationWebApiHandler_getTermSet_Path,
  getParams,
];

export const useIdVerificationWebApiHandler_getTermSet = (
  getParams: GetTermSetParams,
  {
    httpClient,
    ...options
  }: Omit<IdVerificationWebApiHandler_getTermSet_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: IdVerificationWebApiHandler_getTermSet_GetKey(getParams),
    queryFn: () => IdVerificationWebApiHandler_getTermSet(getParams, httpClient),
  });
};
useIdVerificationWebApiHandler_getTermSet.getKey = IdVerificationWebApiHandler_getTermSet_GetKey;

export type IdVerificationWebApiHandler_isIpAddressInTheUs_Options = UseQueryOptions<
  boolean,
  unknown,
  boolean,
  Array<string>
>;

const IdVerificationWebApiHandler_isIpAddressInTheUs_GetKey = () => [
  IdVerificationWebApiHandler_isIpAddressInTheUs_Path,
];

export const useIdVerificationWebApiHandler_isIpAddressInTheUs = ({
  httpClient,
  ...options
}: Omit<IdVerificationWebApiHandler_isIpAddressInTheUs_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: IdVerificationWebApiHandler_isIpAddressInTheUs_GetKey(),
    queryFn: () => IdVerificationWebApiHandler_isIpAddressInTheUs(httpClient),
  });
};
useIdVerificationWebApiHandler_isIpAddressInTheUs.getKey = IdVerificationWebApiHandler_isIpAddressInTheUs_GetKey;

export type IdVerificationWebApiHandler_isUserIdentified_Options = UseQueryOptions<
  IsUserIdentifiedResponseDto,
  unknown,
  IsUserIdentifiedResponseDto,
  Array<string | IsUserIdentifiedParams>
>;

const IdVerificationWebApiHandler_isUserIdentified_GetKey = (getParams: IsUserIdentifiedParams) => [
  IdVerificationWebApiHandler_isUserIdentified_Path,
  getParams,
];

export const useIdVerificationWebApiHandler_isUserIdentified = (
  getParams: IsUserIdentifiedParams,
  {
    httpClient,
    ...options
  }: Omit<IdVerificationWebApiHandler_isUserIdentified_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: IdVerificationWebApiHandler_isUserIdentified_GetKey(getParams),
    queryFn: () => IdVerificationWebApiHandler_isUserIdentified(getParams, httpClient),
  });
};
useIdVerificationWebApiHandler_isUserIdentified.getKey = IdVerificationWebApiHandler_isUserIdentified_GetKey;

export interface IdVerificationWebApiHandler_performIdentityCheck_Args {
  postData: PerformIdentifyCheckRequestDto;
}

export type IdVerificationWebApiHandler_performIdentityCheck_Options = UseMutationOptions<
  PerformIdentifyCheckResponseDto,
  unknown,
  IdVerificationWebApiHandler_performIdentityCheck_Args
>;

export const useIdVerificationWebApiHandler_performIdentityCheck = ({
  httpClient,
  ...options
}: Omit<IdVerificationWebApiHandler_performIdentityCheck_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: IdVerificationWebApiHandler_performIdentityCheck_Args) =>
      IdVerificationWebApiHandler_performIdentityCheck(args.postData, httpClient),
  });
};

export interface IdVerificationWebApiHandler_submitIdentityCheckAnswers_Args {
  postData: SubmitIdentityCheckAnswersForPassiveAuthRequestDto;
}

export type IdVerificationWebApiHandler_submitIdentityCheckAnswers_Options = UseMutationOptions<
  SubmitIdentityCheckAnswersResponseDto,
  unknown,
  IdVerificationWebApiHandler_submitIdentityCheckAnswers_Args
>;

export const useIdVerificationWebApiHandler_submitIdentityCheckAnswers = ({
  httpClient,
  ...options
}: Omit<IdVerificationWebApiHandler_submitIdentityCheckAnswers_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: IdVerificationWebApiHandler_submitIdentityCheckAnswers_Args) =>
      IdVerificationWebApiHandler_submitIdentityCheckAnswers(args.postData, httpClient),
  });
};
